// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router';

const ActionsPopoverListLink = props => (
    <li>
        <Link
            to={props.route}
        >
            <FormattedMessage id={props.label}/>
        </Link>
    </li>
);

ActionsPopoverListLink.displayName = 'ActionsPopoverListLink';
ActionsPopoverListLink.propTypes = {
    label: PropTypes.string.isRequired,
    route: PropTypes.string.isRequired
};

export default ActionsPopoverListLink;



// WEBPACK FOOTER //
// ./src/shared/components/actions-popover/actions-popover-list-link.js